module.exports = __webpack_public_path__ + "static/media/boothBg.a55992e0.jpg";